import { render } from "./PlacePage.vue?vue&type=template&id=488cad65&scoped=true"
import script from "./PlacePage.vue?vue&type=script&lang=js"
export * from "./PlacePage.vue?vue&type=script&lang=js"

import "./PlacePage.vue?vue&type=style&index=0&id=488cad65&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ipc-app/ipc-app/apps/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-488cad65"]])

export default __exports__